import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router";
import { setPageTitle } from "Application";
import { WeeklyRotaSessionReportViewModel } from "./WeeklyRotaSessionReportViewModel";
import { SessionReport } from "Views/Shared/Views/SessionReport/SessionReport";

export const MentorSessionReportView: React.FC = observer(() => {
    const { id, mentorId, reportId, studentId } = useParams();
    const [viewModel] = useState(() => new WeeklyRotaSessionReportViewModel(id, mentorId, reportId, studentId));

    useEffect(() => {
        setPageTitle("Weekly Rota");
        viewModel.initialize();
    }, []);

    return <SessionReport viewModel={viewModel} />;
});

export default MentorSessionReportView;
